import React from 'react'
import { Button, DatePicker, Modal, Select } from 'antd'

import styles from './CompleteSprintModal.module.css'
import SprintStatCard from './SprintStatCard'

const CompleteSprintModal = ({
    open,
    sprintTitle,
    doneCount,
    incompleteCount,
    loading = false,
    moveToSprintId,
    onMoveToChange,
    targetOptions,
    newSprintSelected = false,
    newSprintTitle = '',
    newSprintRange = null,
    onNewSprintRangeChange,
    onCancel,
    onConfirm,
}) => (
    <Modal
        open={open}
        title={
            <div className={styles.completeSprintModalHeader}>
                <span className={styles.completeSprintModalTitle}>
                    Complete Sprint
                </span>
                {sprintTitle ? (
                    <span className={styles.completeSprintModalSubtitle}>
                        {sprintTitle}
                    </span>
                ) : null}
            </div>
        }
        onCancel={onCancel}
        footer={[
            <Button
                key="cancel"
                onClick={onCancel}
                className={styles.completeSprintCancelBtn}
                disabled={loading}
            >
                Cancel
            </Button>,
            <Button
                key="complete"
                type="primary"
                onClick={onConfirm}
                className={styles.completeSprintConfirmBtn}
                disabled={loading}
            >
                Complete Sprint
            </Button>,
        ]}
        className={styles.completeSprintModal}
        width={600}
        destroyOnHidden
        centered
    >
        <div className={styles.completeSprintWrap}>
            {loading ? (
                <div
                    className={styles.completeSprintLoadingStripe}
                    role="status"
                    aria-live="polite"
                    aria-label="Loading sprint summary"
                />
            ) : null}
            <div className={styles.completeSprintBody}>
                <div className={styles.completeSprintStats}>
                    <SprintStatCard label="Done" value={doneCount} tone="success" />
                    <SprintStatCard
                        label="Incomplete"
                        value={incompleteCount}
                        tone="warning"
                    />
                </div>
                <p className={styles.completeSprintDesc}>
                    Select where all the incomplete work items should be moved:
                </p>
                <div className={styles.completeSprintField}>
                    <label
                        className={styles.completeSprintLabel}
                        htmlFor="complete-sprint-move-to"
                    >
                        Move to
                    </label>
                    <Select
                        id="complete-sprint-move-to"
                        value={moveToSprintId}
                        onChange={onMoveToChange}
                        options={targetOptions}
                        placeholder="Select sprint"
                        className={styles.completeSprintSelect}
                        allowClear
                        disabled={loading}
                    />
                </div>
                {newSprintSelected ? (
                    <div className={styles.completeSprintField}>
                        <label className={styles.completeSprintLabel}>
                            New sprint title
                        </label>
                        <div className={styles.newSprintTitlePreview}>
                            {newSprintTitle || 'Sprint 1'}
                        </div>
                        <label className={styles.completeSprintLabel}>
                            New sprint dates
                        </label>
                        <DatePicker.RangePicker
                            value={newSprintRange}
                            onChange={onNewSprintRangeChange}
                            format="MMM D, YYYY"
                            separator="→"
                            className={styles.completeSprintRange}
                            disabled={loading}
                            allowClear={false}
                        />
                    </div>
                ) : null}
            </div>
        </div>
    </Modal>
)

export default CompleteSprintModal
